export const BREATHING_EXERCISES = [
  {
    id: 'square',
    name: 'Respiration Carrée',
    nameEn: 'Square Breathing',
    rhythm: '4-4-4-4',
    description: 'Équilibre mental, clarté et recentrage immédiat.',
    descriptionEn: 'Mental balance, clarity and immediate centering.',
    icon: '▢',
    timings: {
      inhale: 4,
      hold1: 4,
      exhale: 4,
      hold2: 4,
    },
    premium: false, // FREE exercise - square breathing
  },
  {
    id: 'cardiac',
    name: 'Cohérence Cardiaque',
    nameEn: 'Cardiac Coherence',
    rhythm: '5-5',
    description: 'Apaisement global, réduction du stress, harmonie du rythme cardiaque.',
    descriptionEn: 'Overall calming, stress reduction, cardiac rhythm harmony.',
    icon: '❤️',
    timings: {
      inhale: 5,
      hold1: 0,
      exhale: 5,
      hold2: 0,
    },
    premium: true,
  },
  {
    id: 'sleep',
    name: 'Respiration 4-7-8',
    nameEn: '4-7-8 Breathing',
    rhythm: '4-7-8',
    description: 'Sommeil profond',
    descriptionEn: 'Deep sleep',
    icon: '🌙',
    timings: {
      inhale: 4,
      hold1: 7,
      exhale: 8,
      hold2: 0,
    },
    premium: true,
  },
  {
    id: 'calm',
    name: 'Respiration Anti-Stress',
    nameEn: 'Anti-Stress Breathing',
    rhythm: '4-2-6',
    description: 'Apaisement rapide',
    descriptionEn: 'Quick calming',
    icon: '🧘',
    timings: {
      inhale: 4,
      hold1: 2,
      exhale: 6,
      hold2: 0,
    },
    premium: true, // Was free, now premium
  },
  {
    id: 'energize',
    name: 'Respiration Énergétique',
    nameEn: 'Energizing Breathing',
    rhythm: '3-3',
    description: 'Boost d\'énergie',
    descriptionEn: 'Energy boost',
    icon: '⚡',
    timings: {
      inhale: 3,
      hold1: 0,
      exhale: 3,
      hold2: 0,
    },
    premium: true,
  },
  {
    id: 'slow',
    name: 'Respiration Lente',
    nameEn: 'Slow Breathing',
    rhythm: '6-6',
    description: 'Relaxation profonde',
    descriptionEn: 'Deep relaxation',
    icon: '🌊',
    timings: {
      inhale: 6,
      hold1: 0,
      exhale: 6,
      hold2: 0,
    },
    premium: true,
  },
  {
    id: 'deep',
    name: 'Respiration Profonde',
    nameEn: 'Deep Breathing',
    rhythm: '6-0-6',
    description: 'Oxygénation maximale',
    descriptionEn: 'Maximum oxygenation',
    icon: '💨',
    timings: {
      inhale: 6,
      hold1: 0,
      exhale: 6,
      hold2: 0,
    },
    premium: true,
  },
  {
    id: 'guided',
    name: 'Respiration Guidée',
    nameEn: 'Guided Breathing',
    rhythm: '5-5',
    description: 'Avec voix (future)',
    descriptionEn: 'With voice (future)',
    icon: '🎙️',
    timings: {
      inhale: 5,
      hold1: 0,
      exhale: 5,
      hold2: 0,
    },
    premium: true,
    comingSoon: true,
  },
];

export const DURATIONS = [
  { value: 60, label: '1 min' },
  { value: 180, label: '3 min' },
  { value: 300, label: '5 min' },
  { value: 600, label: '10 min' },
];
